function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawOnlineShopping = function UndrawOnlineShopping(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1015.56 783.53",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 535.54,
    y1: 705.46,
    x2: 535.54,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 237.19,
    y1: 818.89,
    x2: 237.19,
    y2: 359.58,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M637.08 126.32c-42.28 26.74-97.12 25-145.17 11.1s-92.2-38.69-139-56.3a490.89 490.89 0 0 0-122.13-28.76c-59.67-6.17-126.3 1.34-167.88 44.57-46.3 48.15-42.75 135 7.33 179.18 25.47 22.48 58.83 33.51 87.92 51.06s56 46.7 53.53 80.58c-2.29 31.36-28.95 55.43-56.54 70.53-21.33 11.67-47.6 24.41-50.17 48.58-2.48 23.39 19.6 41.72 40.69 52.14 68.8 34 153.56 33.67 222.09-.86 24.45-12.32 46.93-28.7 72.57-38.3 67.33-25.21 141.51.17 212.8 9.45a469.33 469.33 0 0 0 181-11.91c35.3-9.42 70.74-23.82 95.54-50.65 17.88-19.35 29-43.83 39.49-68q16.73-38.68 32.16-77.9c6.18-15.7 12.26-31.7 13.85-48.5 2.89-30.43-9.28-60.51-25.87-86.2-39.4-60.99-105.71-103.87-177.51-114.76s-147.79 10.4-203.49 56.93",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 135.74,
    cy: 756.99,
    rx: 135.74,
    ry: 26.54,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("ellipse", {
    cx: 538.99,
    cy: 701.56,
    rx: 284.54,
    ry: 26.54,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M732.13 512.6s39.89-70.66 100-91c25.21-8.55 47.22-24.62 62.27-46.58a207.22 207.22 0 0 0 18.38-33.07",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M950.51 328.89c-6.85 6.64-38.73 13.51-38.73 13.51s7.83-31.65 14.67-38.3a17.273 17.273 0 0 1 24.06 24.79zM932.48 386.18c-9.36 1.85-39.85-9.71-39.85-9.71s23.77-22.32 33.12-24.18a17.28 17.28 0 1 1 6.73 33.89zM866.78 448.17c-9-3.12-29.5-28.49-29.5-28.49s31.79-7.28 40.8-4.16a17.28 17.28 0 1 1-11.3 32.65zM806.57 483.88c-9.41-1.55-33.89-23.11-33.89-23.11s30.1-12.54 39.51-11a17.27 17.27 0 1 1-5.62 34.08zM866.04 351.77c0 9.54 17.26 37.21 17.26 37.21s17.28-27.66 17.29-37.2a17.28 17.28 0 0 0-34.55 0zM796.12 394.4c2.85 9.1 27.59 30.34 27.59 30.34s8.22-31.56 5.37-40.66a17.288 17.288 0 1 0-33 10.32zM733.84 445.19c1.27 9.46 22.08 34.57 22.08 34.57s13.43-29.71 12.16-39.17a17.274 17.274 0 1 0-34.24 4.6z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M950.51 328.89c-6.85 6.64-38.73 13.51-38.73 13.51s7.83-31.65 14.67-38.3a17.273 17.273 0 0 1 24.06 24.79zM932.48 386.18c-9.36 1.85-39.85-9.71-39.85-9.71s23.77-22.32 33.12-24.18a17.28 17.28 0 1 1 6.73 33.89zM866.78 448.17c-9-3.12-29.5-28.49-29.5-28.49s31.79-7.28 40.8-4.16a17.28 17.28 0 1 1-11.3 32.65zM806.57 483.88c-9.41-1.55-33.89-23.11-33.89-23.11s30.1-12.54 39.51-11a17.27 17.27 0 1 1-5.62 34.08zM866.04 351.77c0 9.54 17.26 37.21 17.26 37.21s17.28-27.66 17.29-37.2a17.28 17.28 0 0 0-34.55 0zM796.12 394.4c2.85 9.1 27.59 30.34 27.59 30.34s8.22-31.56 5.37-40.66a17.288 17.288 0 1 0-33 10.32zM733.84 445.19c1.27 9.46 22.08 34.57 22.08 34.57s13.43-29.71 12.16-39.17a17.274 17.274 0 1 0-34.24 4.6z",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M734.43 511.19s7.83-80.76 54.49-123.71a123 123 0 0 0 38.06-67.82 207 207 0 0 0 3.4-37.66",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M859.63 254.77c-3.57 8.85-29.93 28-29.93 28s-5.68-32.11-2.11-41a17.27 17.27 0 0 1 32 12.91zM866.35 314.43c-7.8 5.49-40.36 7.28-40.36 7.28s12.69-30 20.49-35.53a17.27 17.27 0 0 1 19.87 28.25zM831.44 397.71c-9.5.8-38.51-14.09-38.51-14.09s26.11-19.53 35.62-20.33a17.27 17.27 0 1 1 2.89 34.42zM790.84 454.77c-9.23 2.39-40.34-7.38-40.34-7.38s22.44-23.67 31.67-26.06a17.273 17.273 0 0 1 8.67 33.44zM791.66 309.87c3.87 8.72 30.86 27 30.86 27s4.59-32.28.73-41a17.277 17.277 0 0 0-31.59 14zM745.02 377.21c6.3 7.16 37.53 16.55 37.53 16.55s-5.28-32.18-11.57-39.35a17.29 17.29 0 0 0-26 22.8zM708.67 448.88c5 8.13 34.19 22.66 34.19 22.66s.24-32.61-4.75-40.74a17.274 17.274 0 1 0-29.44 18.08z",
    fill: primaryColor
  }), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M281.84 0v705.46h507.4V0h-507.4z"
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M286.29 6.19h498.5v26.89h-498.5z"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M286.29 6.19h498.5v26.89h-498.5z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: "#f6f7f9",
    d: "M286.29 33.08h498.5v666.19h-498.5z"
  }), React.createElement("circle", {
    cx: 299.4,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 311.76,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("circle", {
    cx: 324.12,
    cy: 19.63,
    r: 4.56,
    fill: "#f6f7f9"
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M375.26 74.15h320.55V86.7H375.26z",
    opacity: 0.2
  }), React.createElement("path", {
    fill: primaryColor,
    d: "M653.22 74.15h42.59V86.7h-42.59z"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.2,
    d: "M329.32 330.62h201.72v144.49H329.32zM329.32 143.19h201.72v144.49H329.32zM329.32 515.61h201.72V660.1H329.32zM540.04 330.62h201.72v144.49H540.04zM540.04 143.19h201.72v144.49H540.04zM540.04 515.61h201.72V660.1H540.04z"
  }), React.createElement("path", {
    d: "M931.57 634.5s7.14 9.33-3.29 23.41-19 26-15.55 34.76c0 0 15.73-26.16 28.54-26.52s4.39-15.92-9.7-31.65z",
    fill: "#3acc6c"
  }), React.createElement("path", {
    d: "M931.57 634.5a11.49 11.49 0 0 1 1.46 2.92c12.5 14.68 19.15 28.38 7.14 28.73-11.18.32-24.61 20.32-27.82 25.37a11.06 11.06 0 0 0 .38 1.15s15.73-26.16 28.54-26.52 4.39-15.92-9.7-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M944.84 646.39c0 3.28-.37 5.94-.82 5.94s-.83-2.66-.83-5.94.46-1.74.92-1.74.73-1.55.73 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M949.39 650.31c-2.88 1.57-5.4 2.52-5.61 2.12s1.94-2 4.82-3.57 1.75-.42 2 0 1.67-.09-1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M893.89 634.5s-7.14 9.33 3.29 23.41 19 26 15.55 34.76c0 0-15.73-26.16-28.54-26.52s-4.41-15.92 9.7-31.65z",
    fill: "#3acc6c"
  }), React.createElement("path", {
    d: "M893.89 634.5a11.49 11.49 0 0 0-1.46 2.92c-12.5 14.68-19.15 28.38-7.14 28.73 11.19.32 24.61 20.32 27.82 25.37a9.11 9.11 0 0 1-.38 1.15s-15.73-26.16-28.54-26.52-4.41-15.92 9.7-31.65z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M880.62 646.39c0 3.28.37 5.94.83 5.94s.82-2.66.82-5.94-.46-1.74-.91-1.74-.74-1.55-.74 1.74z",
    fill: "#ffd037"
  }), React.createElement("path", {
    d: "M876.07 650.31c2.89 1.57 5.4 2.52 5.62 2.12s-1.95-2-4.83-3.57-1.75-.42-2 0-1.67-.09 1.21 1.45z",
    fill: "#ffd037"
  }), React.createElement("ellipse", {
    cx: 912.73,
    cy: 752.6,
    rx: 74.6,
    ry: 11.45,
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M951.13 680.1l-.36 2.91-.5 4.12-.21 1.71-.5 4.12-.22 1.72-.5 4.11-5.71 46.8c-.51 4.18-7.33 7.43-15.57 7.43H897.9c-8.24 0-15-3.25-15.56-7.43l-5.72-46.82-.5-4.11-.21-1.72-.51-4.12-.21-1.71-.5-4.12-.36-2.91c-.28-2.31 3.45-4.31 8.07-4.31h60.67c4.65 0 8.35 2 8.06 4.33z",
    fill: "#65617d"
  }), React.createElement("path", {
    fill: "#9d9cb5",
    d: "M950.77 683.01l-.5 4.11h-75.08l-.5-4.11h76.08zM950.06 688.84l-.5 4.12h-73.65l-.51-4.12h74.66zM949.34 694.67l-.5 4.12h-72.22l-.5-4.12h73.22z"
  }), React.createElement("path", {
    d: "M591.61 171.11s-1.83-4.57 10.51-3.43 47.77 5.08 63.09 1.63 24.45-4.55 23.54 0-26.51 14.83-26.51 14.83l-33.15 3.43-24.45-3.89-13.13-7.77z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M688.78 169.31c-.92 4.55-26.51 14.83-26.51 14.83l-33.15 3.43-24.45-3.88-13.12-7.77.09-4.8a2 2 0 0 1 .7-2.21c1.13-1 3.77-1.78 9.81-1.22 12.35 1.14 47.77 5.07 63.09 1.62 12.48-2.81 20.86-4.06 23-2a2 2 0 0 1 .54 2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M708.48 238.54a143.09 143.09 0 0 0-58.82 26.05 10.91 10.91 0 0 0-4.69-5.57 16.47 16.47 0 0 0-4.76-2c-1.53-.39-3 .54-4.35 1.88a24.63 24.63 0 0 0-3.87 5.73c-23.31-16-58.67-26.21-58.67-26.21v-3.2c0-.63.11-1.39.23-2.25s.27-1.62.46-2.55c3-15.26 14.86-50.13 14.86-50.13h13.41l26 5.4 29.25-1.79 29.46-6.13 3.82-.8c6.37 5 13.6 40 16.44 54.9.36 1.89.64 3.45.85 4.6.25 1.3.38 2.07.38 2.07z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M578.16 231.93c.77-14.65 12.41-46.4 14.38-51.67h-3.67s-12.56 37-15.11 51.44a.36.36 0 0 0 0 .11c-.07.39-.14.77-.19 1.13-.12.86-.2 1.62-.23 2.25v3.2s35.36 10.22 58.67 26.21a24.63 24.63 0 0 1 3.87-5.73c-8.91-8.1-42.7-21.3-57.72-26.94zM708.1 236.43c-.09-.51-.2-1.1-.32-1.75-.15-.84-.33-1.79-.53-2.85-2.84-14.92-10.07-49.93-16.44-54.9l-3.82.8c2.32 6.23 17.27 46.91 16 54.85-25 5-50.34 21.25-58 26.44a10.91 10.91 0 0 1 4.69 5.57 143.09 143.09 0 0 1 58.82-26.05s-.15-.77-.4-2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M579.08 231.01c.76-14.65 12.41-46.4 14.38-51.66h-3.68s-12.56 37-15.11 51.43v.11q-.11.6-.18 1.14c-.12.86-.2 1.62-.23 2.25v3.2s35.35 10.21 58.67 26.21a24.21 24.21 0 0 1 3.86-5.73c-8.91-8.08-42.69-21.31-57.71-26.95z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M578.16 231.93c.77-14.65 12.41-46.4 14.38-51.67h-3.67s-12.56 37-15.11 51.44a.36.36 0 0 0 0 .11c-.07.39-.14.77-.19 1.13-.12.86-.2 1.62-.23 2.25v3.2s35.36 10.22 58.67 26.21a24.63 24.63 0 0 1 3.87-5.73c-8.91-8.1-42.7-21.3-57.72-26.94z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M707.19 235.51l-.32-1.75c-.16-.84-.33-1.78-.53-2.85-2.83-14.91-10.07-49.92-16.44-54.9l-3.81.81c2.32 6.23 17.27 46.91 16 54.85-25 5-50.35 21.25-58 26.43a10.93 10.93 0 0 1 4.69 5.58 142.94 142.94 0 0 1 58.81-26.06s-.15-.75-.4-2.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M708.1 236.43c-.09-.51-.2-1.1-.32-1.75-.15-.84-.33-1.79-.53-2.85-2.84-14.92-10.07-49.93-16.44-54.9l-3.82.8c2.32 6.23 17.27 46.91 16 54.85-25 5-50.34 21.25-58 26.44a10.91 10.91 0 0 1 4.69 5.57 143.09 143.09 0 0 1 58.82-26.05s-.15-.77-.4-2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M586.85 198.34s23.2 14.6 28.62-6.78l5.16 1.38s1.7 23.69-35.32 10.17z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M586.85 196.51s23.2 14.6 28.62-6.78l5.16 1.38s1.7 23.69-35.32 10.17z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M659.85 192.25s3 17.47 34.79 9l-1.12-3.3s-21.71 9-29.58-6.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M659.85 190.42s3 17.47 34.79 9l-1.12-3.3s-21.71 9-29.58-6.63z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M638.69 192.02v36.46h5.64s7.8-2.81 7.62-19.2-1.37-20.8-1.37-20.8z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M637.78 191.11v36.46h5.64s7.8-2.81 7.62-19.2-1.38-20.8-1.38-20.8z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M690.78 178.77c-2.3 4.28-23.18 11.31-26.87 12.52l-.56.18s-1.32.34-3.53.8c-6.72 1.4-21.7 4-33 1.72-1.64-.32-3.34-.67-5.07-1l-4-.87c-13-2.89-26.45-6.67-28.84-10 0 0 .65-10.87 2.84-10.58s26.64 10.58 26.64 10.58l.35.05c.63.08 2.06.26 4.07.49 7.94.87 24.67 2.25 33.67-.16.43-.12.83-.24 1.22-.38.68-.23 1.39-.47 2.12-.74 11.58-4.1 28.92-11.44 28.92-11.44s4.58 4.12 2.04 8.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M688.78 169.31c-.92 4.55-26.51 14.83-26.51 14.83l-33.15 3.43-24.45-3.88-13.12-7.77.09-4.8a2 2 0 0 1 .7-2.21c4.35 1.32 26 10.43 26 10.43l.35.05c.63.08 2.06.26 4.07.49 7.94.87 24.67 2.25 33.67-.16.43-.12.83-.24 1.22-.38.68-.22 1.39-.47 2.12-.74 10.47-3.71 25.66-10.07 28.47-11.25a2 2 0 0 1 .54 1.96z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M690.78 176.93c-2.3 4.28-23.18 11.3-26.87 12.51l-.56.19s-1.32.33-3.53.79c-6.72 1.4-21.7 4-33 1.72-1.64-.32-3.34-.67-5.07-1l-4-.87c-13-2.89-26.45-6.67-28.84-10 0 0 .65-10.87 2.84-10.57s26.64 10.57 26.64 10.57l.35.05c.63.08 2.06.27 4.07.49 7.94.87 24.67 2.25 33.67-.16.43-.12.83-.24 1.22-.38.68-.22 1.39-.47 2.12-.74 11.58-4.1 28.92-11.44 28.92-11.44s4.58 4.15 2.04 8.84z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 642.65,
    cy: 188.48,
    r: 3.66,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 642.65,
    cy: 187.56,
    r: 3.66,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M623.68 180.77l-1 10.32-4-.87 1-9.94c.56.1 2 .29 4 .49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M622.78 180.77l-1 10.32-4-.87 1-9.94c.55.1 2 .29 4 .49z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M663.02 189.44l-.56.19s-1.31.33-3.53.79l-3.41-9.79c.43-.12.84-.24 1.23-.38.68-.22 1.39-.47 2.12-.74z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M663.94 189.44l-.56.19s-1.32.33-3.53.79l-3.41-9.79c.43-.12.83-.24 1.22-.38.68-.22 1.39-.47 2.12-.74z",
    fill: primaryColor
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M406.02 162.77a26.4 26.4 0 0 1 13.29 3.69s12.18 1.48 18.82 0 10-6.64 11.26-5.17 1.29 15.32 1.29 15.32l-5.72 15.32-12.92 9.59-20.48-5.9-6.78-17.33z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M450.68 176.63l-5.72 15.32-12.92 9.59-20.48-5.9-6.78-17.35 1.29-15.5h.3a27.12 27.12 0 0 1 13 3.7s12.18 1.48 18.82 0c6.31-1.4 9.63-6.14 11-5.34a.62.62 0 0 1 .21.16c1.28 1.46 1.28 15.32 1.28 15.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M450.68 176.63l-5.72 15.32-12.92 9.59-20.48-5.9-6.78-17.35 1.29-15.5h.3c1.14 4.89 6 20.33 21.48 21.42 15.92 1.11 20.44-17.83 21.38-23.05a.62.62 0 0 1 .21.16c1.24 1.45 1.24 15.31 1.24 15.31z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M406.02 162.77s3.32 21.59 21.78 22.88 21.59-24.36 21.59-24.36 26.76 8.77 33 24.41 10.89 28.19 10.89 28.19-2 3.5-4.25 3.87-17.53 10.89-17.53 10.89-.18 29.9 1.48 31.74 1.11 9.78-3.88 9.41-39.49-8.12-69-1.66c0 0-12.36 4.43-12-2.77s.92-35.43.92-35.43-18.64-8.12-19.74-8.12-3.88-1.46-.93-6.27 6.65-21.22 6.65-21.22 7.4-23.56 31.02-31.56z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M463.41 201.54s5.54 4.06 4.25 7.2-4.25-7.2-4.25-7.2zM471.53 205.44a10 10 0 0 0 0 5.51M475.22 215.57s.74 5-1.47 5.53M399.93 200.25s-10.33 9-6.83 12.55M393.47 222.03s-.17 9.41 2.68 10.15M423.18 253.58s7-4.79 8.86-4.61M430.18 258.57s7.58-5.36 9.61-5",
    opacity: 0.1
  })), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M594.78 344.42s60.38 2.86 90.4 1.1l-.66 7.92-53.12 7-15.72-4.84z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M685.22 345.52l-.66 7.92-53.11 7-15.73-4.84-20.94-11.18s1.24.07 3.45.16c13.1.57 60.27 2.41 86.17 1z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M706.12 458.14c-11.66 7-52.13.22-52.13.22l-11.22-40-12.54 40.69c-17.81 6.38-54.55-2.86-54.55-2.86l14.3-88 2.47-12.13 2.33-11.64 22.66 6.82s6.81 4.62 35.19 3.3 32.55-9 32.55-9c1.25.36 2.44 4.77 3.64 10.25 1.74 8 3.51 18.26 5.6 21.65 3.56 5.7 11.7 80.7 11.7 80.7z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M688.86 356.65c-25.3 13.89-47.08 13.51-47.08 13.51-5.39.66-49.33-13.23-49.33-13.23l2.33-11.63 22.66 6.82s6.81 4.62 35.19 3.3 32.55-9 32.55-9c1.29.35 2.48 4.75 3.68 10.23z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M685.22 345.52l-.66 7.92-53.11 7-15.73-4.84-20.94-11.18s1.24.07 3.45.16l19.2 5.78s6.81 4.62 35.19 3.3c22.29-1 29.65-6 31.78-8.09z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M688.86 355.77c-25.3 13.89-47.08 13.51-47.08 13.51-5.39.66-49.33-13.23-49.33-13.23l2.33-11.63 22.66 6.82s6.81 4.62 35.19 3.3 32.55-9 32.55-9c1.29.34 2.48 4.75 3.68 10.23z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 646.07,
    cy: 364.87,
    r: 2.31,
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 646.07,
    cy: 363.99,
    r: 2.31,
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M587.01 405.35s4.07 12.1 6.93 11.88-6.93-11.88-6.93-11.88zM584.37 417.23s2.53 7.26 5.17 8.47M584.37 424.82s4 5.06 6.37 6.27M691.78 379.07s3.74 5.61 0 6.82M693.48 388.19c-4.34-5.15-1.66 7-1.66 7s2.77-5.68 1.66-7zM695.67 394.46s-6.6 9.79-5.28 10.89M608.36 379.28c-8.09 0-16.53-3.66-17-3.88l.36-.81c.16.08 16.31 7.09 25.05 1.83 3.3-2 5.15-5.52 5.51-10.5l.88.07c-.38 5.28-2.38 9-5.94 11.18a17 17 0 0 1-8.86 2.11z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M608.36 378.4c-8.09 0-16.53-3.66-17-3.88l.36-.8c.16.07 16.31 7.08 25.05 1.82 3.3-2 5.15-5.52 5.51-10.5l.88.07c-.38 5.28-2.38 9-5.94 11.18a17 17 0 0 1-8.86 2.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M674.78 379.94a13.69 13.69 0 0 1-6-1.29c-6.56-3.16-7.62-10.9-7.67-11.23l.88-.11c0 .08 1.05 7.61 7.18 10.55 5.46 2.63 13.21 1 23-5l.45.75c-6.97 4.22-12.94 6.33-17.84 6.33z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M674.78 379.06a13.69 13.69 0 0 1-6-1.29c-6.56-3.16-7.62-10.9-7.67-11.23l.88-.11c0 .08 1.05 7.61 7.18 10.55 5.46 2.63 13.21 1 23-5l.45.75c-6.97 4.22-12.94 6.33-17.84 6.33z",
    fill: primaryColor
  })), React.createElement("path", {
    d: "M411.12 345.77s11.35 15.85 19.06 14.31 8.47-3.23 15.32-14.31l5.62 12.93-6.62 16-7.84 10.15-16.62-2.61-5.38-18.16z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M451.12 358.69l-6.62 16-7.84 10.15-16.62-2.61-5.38-18.16-3.54-18.3s1 1.38 2.56 3.28c3.81 4.55 11.06 12.11 16.5 11 7.6-1.52 8.45-3.19 15.05-13.86l.27-.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M451.12 358.69l-6.62 16-7.84 10.15-16.62-2.61-5.38-18.16-3.54-18.3s1 1.38 2.56 3.28c2.48 8 7.81 20.83 16.5 20.72 9.81-.11 13.77-16.36 15.05-23.55l.27-.45z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M405.12 345.3s-3.85-.46-1.85 4.31 5.69 20.46 3.85 23.69-.92 12-8.92 13.7l2.3 9.07s.46 20-.46 22.93-1.08 19.07-.77 20.76.16 12.77-1.07 13.24-2 5.84 2 6.76 21.07 1.39 24.15 2.31 24.92 0 24.92 0 9.23-1.23 11.54-2 2.77-2.61 2-6.15-4.31-29.23-3.54-32.46.93-34.77.93-34.77-6-2-6-7.85-2.31-21.54 2.46-31.38c0 0-3.85-2.64-4.46-2.17s-6.42-1.22-6.42-1.22-3 26.77-15.55 26.92-18.14-26.92-18.14-26.92.11-2.46-6.97 1.23z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M423.27 431.15s2.59 6.31 6.91 7.23-6.91-7.23-6.91-7.23zM419.27 436.07s8.36 6.77 8 8.16M402.5 396.07s6.62 4.46 6.62 7.69M406.96 410.07s-1.84-6.46-3.07-7.84M403.89 412.53s2.77 5.54 3.07 7.08M457.58 401.3s-8.61 2.62-7.85 5.85M449.69 431.15s11.28-13.08 7.89-12.77-7.89 12.77-7.89 12.77z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M454.19 378.84c0-2.7-.49-7.5-.55-12.85-.06 6.14.55 11.82.55 14.85 0 5.72 5.73 7.75 6 7.84v-2s-6-1.99-6-7.84zM462.78 455.92a15.57 15.57 0 0 1 .27 1.59 10 10 0 0 0-.27-3.59c-.66-3-3.34-22.26-3.62-29.78-.3 5.14 2.92 28.42 3.62 31.78zM399.13 435.97c0-5.49.31-13.06.91-15 .49-1.56.59-7.94.58-13.58 0 5.06-.15 10.2-.58 11.58-.68 2.18-.94 11.56-.91 17zM405.12 347.3c7.07-3.69 6.92-1.23 6.92-1.23s5.54 27.08 18.14 26.92 15.6-26.92 15.6-26.92 5.85 1.69 6.46 1.22 2.66 1 3.79 1.72c.21-.53.43-1.05.68-1.55 0 0-3.85-2.64-4.47-2.17s-6.46-1.22-6.46-1.22-3 26.77-15.55 26.92-18.14-26.92-18.14-26.92.15-2.46-6.92 1.23c0 0-3.13-.36-2.26 3.09.5-1.29 2.21-1.09 2.21-1.09zM398.19 455c1-.37 1.27-7.22 1.21-11-.05 3.8-.4 8.69-1.21 9s-1.2 2-.89 3.63c.16-.86.48-1.49.89-1.63zM407.12 375.3a8.6 8.6 0 0 0 .47-4.11 5.27 5.27 0 0 1-.47 2.11c-1.85 3.23-.93 12-8.93 13.7l.48 1.88c7.48-1.94 6.64-10.41 8.45-13.58z"
  })), React.createElement("path", {
    d: "M451.56 533.41c-3.78 6.88-42.15 0-42.15 0l.1-.69.76-5.33h40.43l.77 5.32z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M451.56 533.41c-3.78 6.88-42.15 0-42.15 0l.1-.69c1.84 0 29.6-.66 42 0z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M409.41 533.41s-6.88 1.72-17.55 30.62-14.45 66.24-14.45 66.24-6 10.16 19.61 10.84c0 0-2.06 6.71 12.39 5.68s12.37-1.02 12.37-1.02 9.29-5.85 13.42-4.82 6.71 1.38 11.18 5.16 18.76 2.24 18.93-.68a27 27 0 0 0 0-4.31s21.85 1.38 17.72-14.45-7.57-41.81-7.57-41.81-11.18-50.75-23.92-51.44-42.13-.01-42.13-.01z",
    fill: primaryColor
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M396.712 641.132l8.094-87.747.687.063-8.094 87.747zM421.412 645.708l.355-92.39.69.003-.355 92.39zM442.67 553.325l.689-.025 3.449 92.735-.69.026zM464.98 641.12c-1.2-52.85-10.2-89.03-10.31-89.35l.67-.17c.09.36 9.14 36.61 10.33 89.55zM410.61 538.57s-1.2.69 0 4M414.06 538.57s-3.27 2.06 0 5.51M444.68 538.57s4.47 4.3 3.44 5.51M448.28 537.54s.7 5.16 3.28 6.54"
  }), React.createElement("g", {
    opacity: 0.5
  }, React.createElement("path", {
    d: "M630.9 529.29s16.88-6.72 24.18 1.48-5 18.18-5 18.18l-5.16 10.3-12.14-1.33-2.86-14.24z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M650.08 548.9l-5.16 10.3-12.14-1.29-2.86-14.23 1-14.39.27-.1c2.14-.79 16.59-5.83 23.5 1.11a5.35 5.35 0 0 1 .41.42c7.28 8.16-5.02 18.18-5.02 18.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M650.08 548.9l-5.16 10.3-12.14-1.29-2.86-14.23 1-14.39.27-.1c2.09 11.45 7.67 16.28 8.61 17l.14.1 3.43-.28c6.67-3.68 10.19-12.43 11.32-15.74a5.35 5.35 0 0 1 .41.42c7.28 8.19-5.02 18.21-5.02 18.21z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M679.56 588.12s-3.72 47.38-2.71 53.1-2.15 6.15-2.15 6.15-13.46 3-16 1-6.87-2.39-6.87-2.39-10 2.29-14.46.58-11.88-1-11.88-1-5.72 3.44-7.3 2.72-3.58-.43-8.16-1.71-7.16-2.44-4.73-10.31.3-32.78.15-35.79-1.57-10.3-3.58-19 3.43-6.87 3.43-6.87c12.75-6.58 7.45-19.47 5.45-25.19s1.14-6 2.71-6 7.59-5.15 7.59-5.15l2.44-2.19 7.44-6.68c1.85 12.51 7.85 17.76 8.85 18.54l.14.11 3.43-.29c8.3-4.57 11.73-17 11.73-17 1 1.7 3.23 3.64 5.72 5.44a98 98 0 0 0 10.17 6.3c6 3.58 1.58 7.16 1.58 7.16-7.3 24.9 3 26 3 26 7.59 1.12 4.01 12.47 4.01 12.47z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M623.31 543.46s-2.15 1.15-2.15 2.43M624.6 545.89s-2.86 3-2.36 3.87M624.6 549.77s-2.15 2.29-1.29 3.58M638.92 549.65l-9 8.69c-.33-9.66-5-17.39-7.3-20.65l7.44-6.68c1.82 12.61 7.87 17.86 8.86 18.64z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M639.78 547.93l-9 8.7c-.32-9.67-5-17.39-7.29-20.66l7.44-6.68c1.85 12.61 7.85 17.86 8.85 18.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M661.66 537.88c-3.6 5.62-10.29 20.46-10.29 20.46l-7.16-8.87c8.3-4.58 11.73-17 11.73-17 1 1.66 3.23 3.6 5.72 5.41z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M660.78 536.16c-3.59 5.63-10.29 20.47-10.29 20.47l-7.14-8.86c8.3-4.57 11.73-17 11.73-17 1 1.65 3.23 3.59 5.7 5.39z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M655.52 627.91s-1.53 13-2.41 13.74M668.11 630.2s1.72 9.3 1 11.45M631.47 630.77s-1.57 8.73 0 9.73M622.18 629.48s-1.3 10.31-1 12.17M670.26 579.24s-4 3.15-3.72 4M673.12 581.25s-7.66 6.44-3.83 5.72 3.83-5.72 3.83-5.72z",
    opacity: 0.1
  })), React.createElement("path", {
    d: "M341 455l.05-.07-.09-.07-.54-.36.11.08a1.79 1.79 0 0 0-2.36.52l-.22.31-12.15 17.48-2.12 3.11c-6.41-1.93-16.82 6.19-22.09 10.85-.33.29-.64.56-.92.82-.42-.94-.67-1.54-.67-1.54-.26 2.86-10.36 7.15-12.72 8.71a8.5 8.5 0 0 1-3.52 1.18c.34-10.87-8.07-22.31-8.07-22.31l-20.55-26.15a23.08 23.08 0 0 1 2.1-13.87c.17-.34.34-.68.53-1h.1a22.74 22.74 0 0 0-1.29 6.83c.05 1.77 1.69 10.35 4 10a1.26 1.26 0 0 0 1.18-.56c1.84-2.14 2-5.78 1.91-9.15a18.75 18.75 0 0 1-.33 2.95c.15-2.8-.17-5.76-.17-7.87 0-.84 0-1.67.06-2.51h.25v0h.26a27.61 27.61 0 0 0 12.55-5.82 6.73 6.73 0 0 0 4.72-2.21 4.59 4.59 0 0 1-.89 4.28c2.75-.13 5.08-2.27 6.14-4.78a16.68 16.68 0 0 0 .78-8 55.59 55.59 0 0 1-.59-8.13 29.91 29.91 0 0 0 .24-4.43 8.54 8.54 0 0 0-.24-1.34h.08a2 2 0 0 0 1.43-.56c1.14-.88 1.51-2.6 1.8-3.92a33.38 33.38 0 0 0 1.06-9.31c-.06.95-.18 1.91-.32 2.86.25-3.6-.25-7.1-2.63-9.71-1.64-1.79-3.93-2.84-6.13-3.89a4.49 4.49 0 0 1-2-1.43 5.79 5.79 0 0 1-.62-2.48c-.77-5.26-5.72-8.92-10.65-11-6.34-2.76-14-3.94-20.05-.66-3 1.59-5.3 4.08-8 6.11-3.38 2.57-7.28 4.37-10.89 6.61s-7 5.08-8.77 8.94c-2.65 6-.66 12.8-.33 19.31.53 10.25-3.69 21-12.05 27a10.81 10.81 0 0 0-2.65 2.29 2.86 2.86 0 0 0-.22 3.27c.43.56 1.11.88 1.58 1.41.95 1.08.76 2.73.39 4.11a25.77 25.77 0 0 1-7 11.86c.15 1.06 1.46 1.48 2.53 1.64a58.25 58.25 0 0 0 8.55.62h1.23c-.13.33-.27.68-.41 1.05-1.55 4.08-3.56 10.36-2.89 14.2 1 6.06 4.2 33.77 2.62 38.63s2.54 40.1 2.54 40.1.55 2.72 1.5 6.78c-2.47 5.82-5.29 12.28-6.7 14.87-2.84 5.19-1.44 31.69 8.35 43.47 0 0 4 5.72 3 7.79s.18 5.72.18 5.72l1.55 34.29a88.88 88.88 0 0 1-.72 10.48c-4.18 5.17-10.62 12.71-13.65 13.94-4.69 1.91-39.67 44.34-39.67 44.34s.28.51.83 1.34l-1 1.14-6.71 7.78-.53.61c-1.26-.24-9.65-1.76-16.3-2.24h-.66v-.12a24.88 24.88 0 0 0-7 .19 2.25 2.25 0 0 0-1.16.6c-2.27 2.78-3.49 46.42-3.49 46.42s2.42 21.85 10 23.07a4 4 0 0 0 1.2.22h.33c5.4-.4 7.88-3.49 9-5.61a8.69 8.69 0 0 0 .75-2s-.88-3.89 1.48-9.26S162 778 162 778s8-8.41 6.57-12.49c.22-.33.48-.69.76-1.1 3-4.28 9.08-12.73 14-18.37.32-.38.64-.73 1-1.08a24.56 24.56 0 0 0 5.58 1.61s7.52-2.94 10.31-9.52c1.19-2.8 5.86-7.76 10.83-12.53l-.16 1.27-.17 41.74a29.83 29.83 0 0 0 5.14 2.83v1a134 134 0 0 1-1.08 17.79l-.15.93c-.62-.44-1.16-.59-1.5-.25-1.54 1.56-2.5 11.52-2.59 16.11v.46c-.25 4.58-2.86 11.24 5 11.58 5.88.25 31.23.63 44.79.83a30.15 30.15 0 0 0 20-7.09c4.31-3.69 6.92-8.08 1.05-11.31-.36-.2-.74-.39-1.16-.58l-13-2-22.21-11.34s-.13-6.86-2.8-5.72a7.5 7.5 0 0 0-2.25.89c-.13-.25-.27-.52-.4-.8a25.55 25.55 0 0 1-2.74-11.56c0-.36 0-.73.05-1.1a22.09 22.09 0 0 0 1.84-1.89s-.17-15.59 1.58-18.53 7.17-32.74 7.17-32.74.17-5.54 3.67-8.83 2.27-12.82 2.27-12.82 4.9-2.6 6.47-11.08 6.65-27 6.65-27 10.49-27.37 9.8-44.68 1-26.33 1-26.33l2.18-40.24v-.62c.87.66 1.46 1.2 1.46 1.2v-.44c.32.27.5.44.5.44s1.12-18.26.74-25.5c6.12-2.08 15.44-5.5 16-7.24.78-2.59 11.28-10.78 11.28-10.78a1.74 1.74 0 0 1-.64-.24c.33-.15.67-.33 1-.52 6.88-3.68 19.66-14.44 17.51-21l14-20.09A3.41 3.41 0 0 0 341 455z",
    transform: "translate(-92.22 -58.23)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M216.21 445.29a9.12 9.12 0 0 1-3.35 1.27c-4.37.13-8-11.7-8-11.7s1.24-1.26 3.22-3c5.86-5.21 18.15-14.83 23.91-9.45 6.5 6.01-8.21 18.81-15.78 22.88zM149.78 727.42l-16.13 17.41s-14.92.17-12-8.06a30.09 30.09 0 0 0 1.24-5.48 134.65 134.65 0 0 0 1.05-17.62c0-3.86-.06-6.57-.06-6.57s23.49-10.29 21.09.43a20.15 20.15 0 0 0-.48 4.08 25.54 25.54 0 0 0 2.68 11.45 25.91 25.91 0 0 0 2.61 4.36z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M149.78 727.42l-16.13 17.41s-14.92.17-12-8.06a30.09 30.09 0 0 0 1.24-5.48c2.13 1.65 5.19 6.51 5.19 6.51s10.29 3 13.12-6c1.58-5 4.08-7.53 6-8.74a25.91 25.91 0 0 0 2.58 4.36z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M187.2 753.64a29.34 29.34 0 0 1-19.64 7c-13.3-.19-38.15-.58-43.92-.82-7.72-.34-5.16-6.93-4.91-11.47v-.45c.09-4.55 1-14.41 2.54-15.95s6.81 6.86 6.81 6.86 10.29 3 13.12-6 8.58-9.87 8.58-9.87c2.61-1.13 2.74 5.66 2.74 5.66l21.78 11.23 12.78 2c.41.19.78.38 1.13.57 5.78 3.24 3.22 7.58-1.01 11.24z",
    fill: "#c17174"
  }), React.createElement("circle", {
    cx: 146.96,
    cy: 735.39,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 155.8,
    cy: 739.77,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 160.34,
    cy: 741.8,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 169.77,
    cy: 745.42,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 164.97,
    cy: 743.88,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M187.2 753.64a29.34 29.34 0 0 1-19.64 7c-13.3-.19-38.15-.58-43.92-.82-7.72-.34-5.16-6.93-4.91-11.47l48.47 3s19.85-3 21-8.92c5.79 3.21 3.23 7.55-1 11.21z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M187.2 753.64a29.34 29.34 0 0 1-19.64 7c-13.3-.19-38.15-.58-43.92-.82-7.72-.34-5.16-6.93-4.91-11.47l48.47 3s19.85-3 21-8.92c5.79 3.21 3.23 7.55-1 11.21z",
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M96.97 683.69a33.47 33.47 0 0 0-4.86 4.88c-4.81 5.58-10.76 14-13.71 18.18-1.14 1.64-1.83 2.67-1.83 2.67l-6.44-.95s-6.94-10.63-6.85-10.88 5.5-11.67 5.5-11.67l2.09-2.45 6.59-7.7 3-3.48s22.32 7.2 16.51 11.4z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M78.4 706.77c-1.14 1.64-1.83 2.67-1.83 2.67l-6.44-.95s-6.94-10.63-6.85-10.88 5.5-11.69 5.5-11.69l2.09-2.45.68.13h1.64c-5.75 6 .42 19.2.42 19.2s2.66.25 4.79 3.97z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M71.21 720.21s-4.29 9.26-6.61 14.58-1.46 9.17-1.46 9.17a9 9 0 0 1-.73 2 10.1 10.1 0 0 1-8.78 5.56h-.42c-7.82-.2-10.3-22.9-10.3-22.9s1.2-43.21 3.43-46a2.14 2.14 0 0 1 1.13-.6 24 24 0 0 1 6.89-.19c7.07.51 16.16 2.25 16.16 2.25h1.63c-5.75 6 .42 19.21.42 19.21s2.75.25 4.89 4.11-6.25 12.81-6.25 12.81z",
    fill: "#c17174"
  }), React.createElement("circle", {
    cx: 61.77,
    cy: 707.35,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("circle", {
    cx: 61.3,
    cy: 714.84,
    r: 0.94,
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M61.78 745.77a10.1 10.1 0 0 1-8.78 5.56h-.41c-7.82-.2-10.31-22.9-10.31-22.9s1.2-43.21 3.43-46a2.14 2.14 0 0 1 1.13-.6 24 24 0 0 1 6.89-.19c-.13 7.77-.5 32.32 0 34.76s4.93 22.86 8.05 29.37z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M61.78 745.77a10.1 10.1 0 0 1-8.78 5.56h-.41c-7.82-.2-10.31-22.9-10.31-22.9s1.2-43.21 3.43-46a2.14 2.14 0 0 1 1.13-.6 24 24 0 0 1 6.89-.19c-.13 7.77-.5 32.32 0 34.76s4.93 22.86 8.05 29.37z",
    fill: "#fff",
    opacity: 0.25
  }), React.createElement("path", {
    d: "M52.58 751.35c-7.82-.2-10.31-22.9-10.31-22.9s1.2-43.21 3.43-46a2.14 2.14 0 0 1 1.13-.6c1.64 2.44 3.08 7.84 1.78 19.72-2.44 22.51.5 23.93.5 23.93s3.67 19.13 3.47 25.85z",
    fill: "#c17174"
  }), React.createElement("path", {
    d: "M52.58 751.35c-7.82-.2-10.31-22.9-10.31-22.9s1.2-43.21 3.43-46a2.14 2.14 0 0 1 1.13-.6c1.64 2.44 3.08 7.84 1.78 19.72-2.44 22.51.5 23.93.5 23.93s3.67 19.13 3.47 25.85zM216.21 445.29a9.12 9.12 0 0 1-3.35 1.27c-4.37.13-8-11.7-8-11.7s1.24-1.26 3.22-3c1.43 3.2 5.37 11.83 8.13 13.43z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M188.17 441.03s3.6.26 5.91-1.28 12.22-5.79 12.48-8.62c0 0 5.91 14.4 9.26 14.92 0 0-10.29 8.1-11.06 10.67s-20.84 8.88-20.84 8.88z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M188.17 441.03s3.6.26 5.91-1.28 12.22-5.79 12.48-8.62c0 0 5.91 14.4 9.26 14.92 0 0-10.29 8.1-11.06 10.67s-20.84 8.88-20.84 8.88zM96.97 683.69a33.47 33.47 0 0 0-4.86 4.88c-7.76-3.25-12.76-9.89-14.66-12.8l3-3.48s22.33 7.2 16.52 11.4z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M133.67 610.77s-12.58 16.81-17.18 18.7-38.89 43.9-38.89 43.9 7.37 13.55 20.92 15.77c0 0 7.37-2.91 10.12-9.43s24.35-24.94 24.35-24.94z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M133.67 610.77s-12.58 16.81-17.18 18.7-38.89 43.9-38.89 43.9 7.37 13.55 20.92 15.77c0 0 7.37-2.91 10.12-9.43s24.35-24.94 24.35-24.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M95.56 667.02a54.84 54.84 0 0 0 11.45 0c6.77-.65 1.67 3.47-11.45 0zM92.47 671.39s9 5.14 12.48 2.57-3.35 2.48-12.48-2.57zM144.99 707.53a20.15 20.15 0 0 0-.48 4.08c-6.95 6.31-15.32 4.36-20.55 2.06 0-3.86-.06-6.57-.06-6.57s23.49-10.33 21.09.43z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M186.66 483.82l-.25 4.74-2.14 39.85s-1.72 8.92-1 26.06-9.64 44.3-9.64 44.3-5 18.35-6.52 26.75-6.34 11-6.34 11 1.2 9.43-2.23 12.69-3.6 8.74-3.6 8.74-5.32 29.5-7 32.42-1.55 18.35-1.55 18.35c-11.14 13.2-27.43 1.2-27.43 1.2l.17-41.33s4.63-38.07 8.06-43.39 3.43-19.89 3.43-19.89l-1.53-34s-1.22-3.6-.17-5.66-2.93-7.71-2.93-7.71c-9.61-11.67-11-37.91-8.19-43s11.12-25.72 11.12-25.72l11.47-6.69 20.73.61z",
    fill: "#5e5a6b"
  }), React.createElement("path", {
    d: "M137.88 685.92s2.71 9.39 4.89 10.42-4.89-10.42-4.89-10.42zM141.61 654.67s7 5.54 10 5.53-10-5.53-10-5.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M183.92 422.51v11.32l-7.47-3.22-7.45-3.21-16.22-15.95s-12.83-8.33-19.69-15.92c-3.92-4.33-5.89-8.42-2.44-10.58a21.5 21.5 0 0 0 4.49-3.93 73.82 73.82 0 0 0 8.94-13.2c.11-.19.22-.38.32-.57 3.34-6.13 5.55-11.36 5.55-11.36s9.4 3 15.44 7.28c.49.34.95.69 1.39 1.05 3.37 2.76 5.05 6 1.94 9.16a24 24 0 0 0-2.21 2.64 21.67 21.67 0 0 0-1.38 2.16c-.18.34-.36.67-.52 1a23.06 23.06 0 0 0-2.06 13.73z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M182.55 341.77c.39.68.93 1.26 1.29 1.95a9.37 9.37 0 0 1 .57 4.8 27.3 27.3 0 0 0 .5 7.66c.53 2.26 1.52 4.44 1.6 6.76.11 3.27-1.59 6.3-3.23 9.13a6.57 6.57 0 0 0 4.7-2.19 4.56 4.56 0 0 1-.86 4.23c2.69-.13 5-2.25 6-4.73a16.49 16.49 0 0 0 .77-8 54.6 54.6 0 0 1-.58-8.05 29.43 29.43 0 0 0 .23-4.39c-.25-2.91-2-5.44-3.76-7.8l-3.48-4.78a2.46 2.46 0 0 0-1-.91c-3.29-1.4-3.67 4.66-2.75 6.32z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M168.78 373.38a24 24 0 0 0-2.21 2.64 21.67 21.67 0 0 0-1.38 2.16c-.18.34-.36.67-.52 1a27 27 0 0 1-20.21-10.92c-.11-.15-.22-.3-.32-.46.11-.19.22-.38.32-.57 3.34-6.13 5.55-11.36 5.55-11.36s9.4 3 15.44 7.28c.49.34.95.69 1.39 1.05 3.33 2.78 5.01 5.98 1.94 9.18z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M193.16 351.21a27 27 0 0 1-22.11 26.56 27.31 27.31 0 0 1-4.9.44h-1a27 27 0 1 1 28-27z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M169.69 417.97s13.6 7.67 10.12 1.2l-17.75-26.24 20.15 25.89s12.86 17.67 5.83 29.84c0 0-1 10.12.17 12.52s-.34 28-.34 28-4.81-4.46-7.38-3.61-20.71 2.37-20.71 2.37z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M186.66 483.82l-.25 4.74c-1.63-1.18-3.9-2.5-5.41-2-2.57.86-20.74 2.41-20.74 2.41l.83-5.91z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M170.2 417.97s13.61 7.67 10.12 1.2l-17.75-26.24 20.15 25.89s12.86 17.67 5.83 29.84c0 0-1 10.12.17 12.52s-.34 28-.34 28-4.8-4.46-7.37-3.61-20.75 2.41-20.75 2.41z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M177.47 431.12c-.79 8.25-4.18 18.06-4.18 18.06s-2.4 24.35-5.51 31.59-1.72 17.15-3.43 35.5c-.62 6.61-2.75 11.15-5.62 14.21-4.72 5-11.46 6.09-16.78 5.78l-1.26-.1c-8.58-.85-16.81-42.18-16.81-42.18s-3.94-35.16-2.4-40-1.52-32.21-2.55-38.21c-.66-3.81 1.31-10 2.83-14.06.89-2.34 1.62-4 1.62-4s2.92-9.26 7.72-14.06a7.08 7.08 0 0 1 5.09-2.14 12.73 12.73 0 0 1 6.35 2 1.77 1.77 0 0 1 .22.15s31.22 31.9 34.13 39.27c.81 2.07.89 5.01.58 8.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M176.45 430.61c-.8 8.24-4.19 18.05-4.19 18.05s-2.4 24.36-5.49 31.56-1.71 17.15-3.43 35.5c-.62 6.6-2.75 11.14-5.62 14.21-4.72 5-11.46 6.08-16.78 5.78l-1.26-.1c-8.58-.86-16.81-42.19-16.81-42.19s-3.94-35.15-2.4-39.95-1.54-32.24-2.57-38.25c-.66-3.8 1.31-10 2.83-14.06.89-2.34 1.62-3.95 1.62-3.95s2.92-9.26 7.72-14.06a7 7 0 0 1 5.09-2.13 12.52 12.52 0 0 1 6.35 2l.22.14s31.22 31.9 34.13 39.27c.81 2.05.92 5 .59 8.18z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M141.48 556.15s-7.08 6.3-9.52 6 9.52-6 9.52-6zM143.36 562.2s-7.46 3.46-9.69 4 6.81-4.89 9.69-4zM172.22 467.53s11.06.13 12.73 3.6-9.17-5.02-12.73-3.6zM170.67 473.57s8.49 1.8 11.06 3.86-11.06-3.86-11.06-3.86zM156.4 452.61s-1 34.85-4.82 39.36 4.82-39.36 4.82-39.36zM146.88 551.13s-7.1 30.74 7.14 32.64 9.84-35 9.84-35z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M146.36 550.62s-7.06 30.74 7.15 32.66 9.83-35 9.83-35z",
    fill: "#ecb4b6"
  }), React.createElement("path", {
    d: "M192.99 348.23a10.41 10.41 0 0 1-1-1.87c-1.89-3.94-6.75-2-10.31-.13l-1.9 2.45a15.25 15.25 0 0 0-2.17 3.35 25.35 25.35 0 0 0-.91 3c-.49 1.74-1.21 3.4-1.86 5.1a59.29 59.29 0 0 0-3.79 17.64 27.31 27.31 0 0 1-4.9.44h-.12v-.12c.18-.68.33-1.37.47-2.06a35.68 35.68 0 0 0 .27-11.8v-.26c-.13-.87-.3-1.75-.37-2.62-.33.6-.65 1.21-1 1.83-2.15 4-4.41 8-8.47 9.75a17.37 17.37 0 0 1-5.15 1.16 29.38 29.38 0 0 0-6.44 1.07 4 4 0 0 0-1.87 1.13 5.52 5.52 0 0 0-.94 2.82 22.73 22.73 0 0 1-1 3.91 34.28 34.28 0 0 1-8.4 12.52l-.93.9a17.41 17.41 0 0 1-5.56 3.85 17 17 0 0 1-5.89.88c.89-2.34 1.62-3.95 1.62-3.95s2.92-9.26 7.72-14.06a7 7 0 0 1 5.09-2.13 75.53 75.53 0 0 0 9.26-13.77 27 27 0 1 1 48.57-19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M194.71 327.16c-1.6-1.78-3.85-2.82-6-3.85a4.57 4.57 0 0 1-1.95-1.42 5.94 5.94 0 0 1-.6-2.45c-.75-5.22-5.61-8.83-10.44-10.95-6.22-2.73-13.69-3.9-19.66-.66-2.9 1.58-5.19 4.05-7.81 6.06-3.32 2.54-7.14 4.32-10.68 6.54s-6.92 5-8.6 8.86c-2.6 5.9-.65 12.67-.32 19.11.51 10.16-3.62 20.77-11.82 26.78a10.32 10.32 0 0 0-2.6 2.27 2.85 2.85 0 0 0-.21 3.23c.41.56 1.09.88 1.54 1.4.94 1.07.75 2.7.38 4.08a25.52 25.52 0 0 1-6.86 11.73c.14 1.06 1.42 1.47 2.47 1.63a56.1 56.1 0 0 0 8.39.61 14.1 14.1 0 0 0 11.73-4.73c5-4.7 9.23-10.57 10.36-17.33a5.71 5.71 0 0 1 .94-2.82 4.23 4.23 0 0 1 1.87-1.13c3.73-1.28 8-.65 11.59-2.23 4.68-2 7-7 9.45-11.58.08.87.24 1.75.38 2.63a35.56 35.56 0 0 1-.7 14.12c-.67 2.61-1.64 5.21-1.57 7.9.05 2 2.08 12.45 4.75 9.32s1.69-10.05 1.69-13.93a59.55 59.55 0 0 1 3.93-21.25c.64-1.69 1.37-3.36 1.86-5.1a27.33 27.33 0 0 1 .9-3 15.67 15.67 0 0 1 2.18-3.35l1.91-2.45c3.56-1.89 8.42-3.81 10.31.13.72 1.51 1.11 3.18 3 1.71 1.11-.87 1.47-2.58 1.76-3.88 1.19-5.45 2.17-11.86-1.57-16z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M158.52 421.57c-.73-18.47-26.58-22.29-32.61-4.82a2.53 2.53 0 0 0-.12.36c-3.95 11.83-2.23 41.79-2.23 41.79s.51 20.12 2.4 26.81 7.2 25.89 7.2 29 4.93 14.92 7 15.78 3.12 7.54 3.63 8.74 2 16.81 2 16.81 19.38-1.2 19.72-4.29-4.29-18.18-4.29-18.18-3.41-6.17-3.85-11.14-3.12-7.23-2.59-10.66-1.55-5.14-1.55-7.37-1.54-8.23-1.54-8.23-3.26-2.58-2.74-5.66-4.63-9.26-3.26-11.49 1.71-7.72 1.71-7.72 1.72-24.69 2.92-31.38 8.23-17.49 8.23-17.49l-.03-.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M157.72 529.93c-4.72 5-11.46 6.08-16.78 5.78-.62-2.34-1.52-5.22-2.83-5.76-2.08-.86-7-12.69-7-15.77s-5.31-22.3-7.2-29-2.4-26.8-2.4-26.8-1.72-30 2.23-41.8c0-.11.07-.23.12-.35 6-17.48 31.88-13.65 32.61 4.82v.85s-7 10.8-8.23 17.49-2.9 31.38-2.9 31.38-.35 5.49-1.72 7.72 3.77 8.41 3.26 11.49 2.74 5.66 2.74 5.66 1.54 6 1.54 8.24 2.06 3.94 1.55 7.37 2.23 5.66 2.67 10.63a27.72 27.72 0 0 0 2.34 8.05z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M157.49 421.06c-.73-18.47-26.58-22.29-32.61-4.82l-.12.35c-3.95 11.84-2.23 41.8-2.23 41.8s.51 20.11 2.4 26.8 7.2 25.9 7.2 29 4.93 14.92 7 15.78 3.12 7.55 3.63 8.75 2 16.8 2 16.8 19.38-1.2 19.72-4.28-4.28-18.18-4.28-18.18-3.42-6.18-3.86-11.15-3.18-7.2-2.66-10.63-1.55-5.15-1.55-7.38-1.54-8.23-1.54-8.23-3.26-2.57-2.74-5.66-4.63-9.26-3.26-11.49 1.71-7.71 1.71-7.71 1.72-24.7 2.92-31.39 8.23-17.49 8.23-17.49.06-.32.04-.87z",
    fill: "#ff748e"
  }), React.createElement("path", {
    d: "M125.66 468.56c.51-.52 10.29-11.32 13.37-7.46s-13.37 7.46-13.37 7.46zM126.56 476.92c.38-.39 9.77-.77 12.09-6s-12.09 6-12.09 6z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M115.86 382.08a2.65 2.65 0 0 1 .51.93 4 4 0 0 0-.51-3.5c-.46-.53-1.13-.84-1.55-1.4 0 0-.05-.09-.08-.14a2.65 2.65 0 0 0 .08 2.71c.47.56 1.09.88 1.55 1.4zM128.95 348.77v-2.92c-.18-3.5-.83-7.09-1-10.6-.21 4.3.75 8.81 1 13.17 0 .1-.01.21 0 .35zM169.03 391.71c-2.38 2.79-4.25-5.24-4.66-8.41a13.19 13.19 0 0 0-.09 1.66c.06 2 2.08 12.45 4.75 9.32 1.81-2.12 2-5.73 1.88-9.06-.13 2.55-.53 4.91-1.88 6.49zM166.55 362.94a34.41 34.41 0 0 1 .37 4.06 35.14 35.14 0 0 0-.37-6.64c-.13-.87-.3-1.75-.38-2.63-2.47 4.62-4.76 9.56-9.44 11.59-3.63 1.57-7.86.95-11.59 2.23a4 4 0 0 0-1.87 1.13 5.58 5.58 0 0 0-.94 2.82c-1.14 6.76-5.38 12.63-10.37 17.33a14.1 14.1 0 0 1-11.73 4.73 57.32 57.32 0 0 1-8.38-.61 6.33 6.33 0 0 1-1.26-.33c-.39.44-.8.86-1.22 1.27.14 1.06 1.43 1.47 2.48 1.63a56 56 0 0 0 8.38.61 14.1 14.1 0 0 0 11.73-4.73c5-4.7 9.23-10.57 10.37-17.33a5.61 5.61 0 0 1 .94-2.82 4.12 4.12 0 0 1 1.87-1.13c3.73-1.28 8-.65 11.59-2.23 4.68-2 7-7 9.44-11.58.08.87.25 1.75.38 2.63zM196.57 340.59c-.29 1.3-.66 3-1.77 3.88-1.88 1.46-2.26-.2-3-1.71-1.89-3.94-6.75-2-10.31-.13l-1.91 2.45a15.25 15.25 0 0 0-2.17 3.35 23.57 23.57 0 0 0-.9 3c-.5 1.74-1.22 3.4-1.87 5.09a59.85 59.85 0 0 0-3.92 21.25v1.06a59.7 59.7 0 0 1 3.91-19.73c.65-1.69 1.37-3.36 1.87-5.1a23.57 23.57 0 0 1 .9-3 15.25 15.25 0 0 1 2.17-3.35l1.91-2.45c3.56-1.89 8.42-3.81 10.31.13.73 1.51 1.11 3.18 3 1.71 1.11-.87 1.48-2.58 1.77-3.88a33.91 33.91 0 0 0 1-9.22 44.09 44.09 0 0 1-.99 6.65z"
  })), React.createElement("path", {
    d: "M219.96 437.95l.53.36a2.12 2.12 0 0 1-.55-3l23.84-34.54a2.11 2.11 0 0 1 2.95-.54l-.53-.37a3.41 3.41 0 0 1 .87 4.74l-22.37 32.47a3.42 3.42 0 0 1-4.74.88z",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M246.456 399.99l.403.279-26.241 38.096-.404-.278a1.74 1.74 0 0 1-.446-2.42l24.262-35.222a1.74 1.74 0 0 1 2.42-.446z",
    fill: "#9f9eff"
  }), React.createElement("rect", {
    x: 334.37,
    y: 463.08,
    width: 0.43,
    height: 3.77,
    rx: 0.17,
    ry: 0.17,
    transform: "rotate(34.56 382.104 287.678)",
    fill: "#464353"
  }), React.createElement("path", {
    d: "M749.4 282a17.27 17.27 0 1 1-17.27-17.23A17.27 17.27 0 0 1 749.4 282zm-19.27 9.14l12.82-12.81a1.12 1.12 0 0 0 0-1.57l-1.58-1.58a1.1 1.1 0 0 0-1.57 0l-10.45 10.45-4.88-4.86a1.13 1.13 0 0 0-1.58 0l-1.57 1.58a1.1 1.1 0 0 0 0 1.57l7.24 7.24a1.1 1.1 0 0 0 1.57 0zM540.19 471.54a17.27 17.27 0 1 1-17.27-17.27 17.27 17.27 0 0 1 17.27 17.27zm-19.27 9.14l12.86-12.81a1.11 1.11 0 0 0 0-1.58l-1.62-1.52a1.11 1.11 0 0 0-1.58 0l-10.45 10.4-4.88-4.88a1.1 1.1 0 0 0-1.57 0l-1.58 1.57a1.13 1.13 0 0 0 0 1.58l7.24 7.24a1.11 1.11 0 0 0 1.58 0zM540.19 660.2a17.27 17.27 0 1 1-17.27-17.27 17.27 17.27 0 0 1 17.27 17.27zm-19.27 9.14l12.86-12.81a1.11 1.11 0 0 0 0-1.58l-1.57-1.57a1.11 1.11 0 0 0-1.58 0l-10.45 10.45-4.88-4.88a1.1 1.1 0 0 0-1.57 0l-1.58 1.57a1.13 1.13 0 0 0 0 1.58l7.24 7.24a1.11 1.11 0 0 0 1.58 0z",
    fill: "#3acc6c"
  }));
};
UndrawOnlineShopping.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawOnlineShopping;